module.exports = __webpack_public_path__ + "static/img/1_1_5.64c84f5a.jpg";